import { createContext, Dispatch, SetStateAction } from "react";

// Define the shape of a single chat message
interface ChatMessage {
  text: string;
  isBot: boolean;
  chartImage?: string;
  questionCategory?: string;
  embeddedQuestion?: string;
  isFollowUp?: number;
}

// Define the shape of the context value
export interface AppContextType {
  chatMessages: ChatMessage[];
  setChatMessages: Dispatch<SetStateAction<ChatMessage[]>>;
  chatHistory: any[];
  setChatHistory: Dispatch<SetStateAction<any[]>>;
  submittedFeedback: number[];
  setSubmittedFeedback: Dispatch<SetStateAction<number[]>>;
  user: any;
  setUser: Dispatch<SetStateAction<any>>;
  surveyResult: any[];
  setSurveyResult: Dispatch<SetStateAction<any[]>>;
}

// Create the context with a default value
const AppContext = createContext<AppContextType | null>(null);

export default AppContext;